<template>
  <router-link
    v-if="workspace?.id != currentWorkspaceId"
    v-slot="{ href, navigate, isActive }"
    :to="route"
    custom
  >
    <div class="workspacefolders-nav__entry workspacefolders-nav__entry-block">
      <a
        class="workspacefolders-nav__link"
        :href="href"
        :class="{ 'is-active': isActive }"
        @click="navigateAndClose(navigate, $event)"
      >
        <template v-if="workspace.organizationSlug">
          {{ workspace.name }}
        </template>
        <template v-else>
          {{ $t("labels.personalWorkspace") }}
        </template>

        <span
          v-if="
            !workspace.isPersonal && workspace?.membership?.accepted == null
          "
          class="workspaceswitcher-entry__invitation"
        >
          <svg-symbol name="circle-filled" />
        </span>
      </a>
    </div>
  </router-link>
  <div
    v-else
    class="workspacefolders-nav__entry workspacefolders-nav__entry-block is-active"
  >
    <a
      :href="$route.fullPath"
      class="workspacefolders-nav__link"
      @click.prevent="$emit('close')"
    >
      <!-- <template v-if="workspace.organizationSlug">
        {{ workspace.organizationName }} /
      </template> -->
      {{ workspace?.name }}
    </a>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import {
  getRouteToFolder,
  getRouteToWorkspace
} from "@core/routes/routeDetector";

import SvgSymbol from "@core/ui/SvgSymbol.vue";
import type { NavigationFailure } from "vue-router";
import type { Workspace } from "@/api/Workspace";

const props = defineProps<{
  workspace: Workspace;
  currentWorkspaceId: number | null;
}>();

const emit = defineEmits<{
  (event: "close"): void;
}>();

const folders = computed(() => {
  return props.workspace?.folders ?? [];
});
const orderedFolders = computed(() => {
  return [...folders.value].sort((a, b) => a?.order - b?.order);
});
const route = computed(() => {
  if (folders.value.length == 0) {
    return getRouteToWorkspace(props.workspace);
  } else {
    return getRouteToFolder(orderedFolders.value[0]);
  }
});

function navigateAndClose(navigate: (e?: MouseEvent) => Promise<void | NavigationFailure>, $event: MouseEvent) {
  navigate($event).then(() => {
    emit("close");
  });
}
</script>

<style lang="scss">
.workspaceswitcher-entry {
  &__invitation {
    position: absolute;
    top: 0.3rem;
    left: 0.3rem;
    color: var(--color-action);
  }
}
</style>
